import type {Component} from 'grapesjs';
import type {PrimaryConfigOptions} from '@/email-maker/grapesjs-email-editor-plugin/src';

let CMDS;

const getPmwWrapper = (rootComponent: Component): Component => {
  if (!rootComponent?.components()) {
    return rootComponent;
  }

  return rootComponent.is(window.PMW.emails.components.container.PMW_WRAPPER) ? rootComponent : getPmwWrapper(rootComponent.getChildAt(0));
};
/**
 * @param {object} opt The grapesjs config object
 */
export default (opt: PrimaryConfigOptions): void => {
  const {editor} = opt;
  const cmds = editor.Commands;

  CMDS = window.PMW.emails.commands;

  cmds.add(CMDS.SET_DEFAULT_SELECTION, (editorInstance) => {
    editor.select(getPmwWrapper(editorInstance.getWrapper() as Component));
  });
};
